import FullTable from 'js/components/full-table/index.js'
import template from './table-agenttype-callcenter.pug'

export default Vue.extend({
  name: 'table-agenttype-callcenter',
  template: template(),
  components: {
    FullTable
  },
  props: {
    items: {
        type: Array,
        required: true
    }
  },
  data() {
    return {
      order: {
        orderBy: null,
        orderDir: null
      },
      data: [],
      tfoot: {
        leadsCount: 0,
        salesCount:0,
        nogestionableCount:0,
        gestionableCount:0,
        notifipicarCount:0
      }
    }
  },
  watch: {
    items() {
      this.setData()
    }
  },
  mounted() {
    this.setData()
  },
  methods: {
    setData() {
      this.data = []//this.items  
      const auxData = []  
      this.items.forEach(items => {
        auxData.push({
          ...items
        })
      })

      this.tfoot.leadsCount = 0;
      this.tfoot.salesCount = 0;
      this.tfoot.nogestionableCount = 0;
      this.tfoot.gestionableCount = 0;
      this.tfoot.notifipicarCount = 0;

      auxData.forEach(item => {
        this.tfoot.leadsCount += item.leadsCount
        this.tfoot.salesCount += item.salesCount
        this.tfoot.nogestionableCount += item.nogestionableCount
        this.tfoot.gestionableCount += item.gestionableCount
        this.tfoot.notifipicarCount += item.notifipicarCount
      })
     
      this.data = auxData
    },
    changeOrder(params) {
      const filter = Object.keys(params.order)[0]
      this.order.orderBy = filter
      this.order.orderDir = params.order[filter]
      this.applyOrder()
    },
    applyOrder() {
      const dir = this.order.orderDir === 'asc' ? 1 : -1
      if (this.order.orderBy && this.order.orderDir) {
        this.data = this.data.sort((a, b) => {
          const x = a[this.order.orderBy]
          const y = b[this.order.orderBy]
          if (x < y) return dir * -1
          if (x > y) return dir
          return 0
        })
      }
    },
    t(key, params = {}) {
      return this.$i18n.t(`analytics.index.agenttypecallcenter.${key}`, params)
    }
  }
})
